export default __webpack_public_path__ + "static/media/refresh-load-hook.237135c9.png";